module.exports = __webpack_public_path__ + "static/media/Scherrie P.de34a5dc.png";